import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service =  {
    name: 'PipelineMonthly',
    label: 'Pipeline Monthly',
    permissionId: 'pipelinemontly',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  data: [
  ],
  layers: [
    // {
    //   name: 'Sentinel1Arctic',
    //   label: 'Sentinel 1 (75 m)',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel1Arctic',
    //   secondary: true
    // },
    {
      name: 'PlanetMosaic',
      label: 'Monthly mosaic',
      opacity: 'raster-opacity',
      datetimeId: 'PlanetMosaic',
      secondary: true,
      hidden: true
    },
    {
      name: 'PipelineMonthly',
      label: 'Monthly mosaic',
      opacity: 'raster-opacity',
      datetimeId: 'PlanetMosaic',
      secondary: false,
      open: true
    },
    // {
    //   name: 'PipelineGreenEn2',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreenEn2',
    //   secondary: true
    // },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
    {
      name: 'EnbridgePipeline',
      label: 'Enbridge Pipeline',
      opacity: 'vector-opacity',
      hidden: true,
    },
    ],
  locations: [
    {
      name: 'MackinawCity',
      label: 'Mackinaw City',
      latitude: 45.8911,
      longitude: -84.8068,
      zoom: [13]
    }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PipelineMonthly.js